import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { breakpoints } from '../ModalUpsell.styles';
import innerSvg from '../../Icons/score-dial-inner.svg';
import dialSvg from '../../Icons/score-dial-new.svg';

const Wrapper = styled.div`
  position: relative;
  width: ${rem(90)};
  height: ${rem(90)};
  margin: ${rem(14)} auto ${rem(-2)};
  display: block;

  @media only screen and (min-width: ${breakpoints.mobile}) {
    width: ${props => (props.isInactive ? rem(81) : rem(64))};
    height: ${props => (props.isInactive ? rem(81) : rem(64))};
  }
`;

const LayerImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
`;

const DialLayerImg = styled(LayerImg)`
  filter: ${props => (props.isInactive ? 'grayscale(100%)' : 'none')};
`;

const InnerLayerImg = styled(LayerImg)`
  top: ${rem(5)};
  filter: ${props => (props.isInactive ? 'grayscale(100%)' : 'none')};
`;

const CombinedScoreDial = ({ className, alt = 'Score dial graphic' }) => (
  <Wrapper className={className} aria-label={alt}>
    <DialLayerImg src={dialSvg} alt="" />
    <InnerLayerImg src={innerSvg} alt="" />
  </Wrapper>
);

CombinedScoreDial.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
};

export default CombinedScoreDial;
